import { AddCircle, Close } from "@mui/icons-material";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Collapse,
  Box,
  IconButton,
} from "@mui/material";
import { FC, useContext, useEffect } from "react";
import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";
import EmptyListAlert from "../../../../EMR/components/layouts/EmptyListAlert";
import { getvitalsById } from "../service";
import { VitalsDto } from "../types";
import AddVitals from "./AddVitals";
import { VitalsContext, VitalsProvider } from "./VitalsProvider";
import Edit from "@mui/icons-material/Edit";
import usePopup from "@hooks/usePopup";

const VitalsList: FC = () => {
  const { encounterId } = useParams();
  const context = useContext(VitalsContext);
  const { showSnackbar } = usePopup();
  if (!context) {
    throw new Error("VitalsContext must be used within a VitalsProvider");
  }
  const { list, edit, setEdit, setList, success, setsuccess, show, setShow } =
    context;

  const { mutate: getVitals, data: vitalsDataList } = useMutation(
    getvitalsById,
    {
      onSuccess: (data) => {
        data?.length > 0 && setShow(true);
        setsuccess(false);
        setList(data);
      },
      onError: () => {
        showSnackbar({
          message: "Something went wrong !",
          open: true,
          variant: "error",
          duration: 3000,
        });
      },
    }
  );

  useEffect(() => {
    getVitals(parseInt(encounterId as string));
  }, [success]);

  return (
    <TableContainer component={Paper}>
      <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow
            sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
          >
            {heading.map((heading, index) => (
              <TableCell
                sx={(theme) => ({ color: theme.palette.background.paper })}
                align="left"
                key={`heading${index}`}
              >
                {heading}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
              <EmptyListAlert
                alert="No Vitals Found"
                isData={Boolean(vitalsDataList?.length || show)}
              >
                {!show && list?.length == 0 && (
                  <div className="w-full flex justify-end items-center p-2 gap-3">
                    <Button
                      color="success"
                      endIcon={<AddCircle />}
                      onClick={() => {
                        setShow(true);
                        setEdit(null);
                      }}
                    >
                      Add
                    </Button>
                  </div>
                )}
              </EmptyListAlert>
              <Collapse
                in={show && list?.length == 0}
                timeout="auto"
                unmountOnExit
              >
                <Box>
                  <AddVitals close={() => setShow(false)} />
                </Box>
              </Collapse>
            </TableCell>
          </TableRow>
          {vitalsDataList?.map((row: VitalsDto, index: number) => (
            <Fragment key={`vitalsList${index}`}>
              <TableRow key={`vitals${index}`}>
                <TableCell>{row.height}</TableCell>
                <TableCell>{row.weight}</TableCell>
                <TableCell>{row.temperature}</TableCell>
                <TableCell>
                  {Boolean(edit) && edit?.vitalId === row.vitalId ? (
                    <IconButton
                      color="error"
                      onClick={() => {
                        setEdit(null);
                      }}
                    >
                      <Close />
                    </IconButton>
                  ) : (
                    <IconButton
                      color="primary"
                      onClick={() => {
                        console.log(row);
                        setEdit(row);
                      }}
                    >
                      <Edit />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
                  <Collapse
                    in={Boolean(edit) && edit?.vitalId === row.vitalId}
                    timeout="auto"
                    unmountOnExit
                  >
                    <AddVitals close={() => setEdit(null)} />
                  </Collapse>
                </TableCell>
              </TableRow>
            </Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const App: FC = () => {
  return (
    <VitalsProvider>
      <VitalsList />
    </VitalsProvider>
  );
};

export default App;

const heading = ["Height", "Weight", "Temperature", "OPTIONS"];
